module.exports = __webpack_public_path__ + "static/footer-bg.464ba9d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/footer-bg.png
// module id = 812
// module chunks = 35783957827783